import type { ComponentPropsWithoutRef } from 'react';
import { cn } from 'src/utils/cn';

export const HeaderPrimaryBackground = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div {...props} className={cn(`bg-legacy-brand`, className)} />;
};

export const HeaderPrimaryCenter = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      {...props}
      className={cn(
        `
          flex min-h-[4.6rem] items-center justify-between gap-[2rem] px-0
          py-[0.6rem]
        `,
        className
      )}
    />
  );
};
